export default "__VITE_ASSET__CmIM6MtZ__"